export default __webpack_public_path__ + "static/media/check_mark.8cbe0f87.svg";